"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _dropdown = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _ModeratorTags = require("@insided/shared/modules/ModeratorTags");

var _listGroup = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/list-group"));

var _chip = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/chip"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _ArrowDropdown = _interopRequireDefault(require("@insided/shared/icons/ArrowDropdown"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ModeratorTagsComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ModeratorTagsComponent, _Component);

  var _super = _createSuper(ModeratorTagsComponent);

  function ModeratorTagsComponent(props) {
    var _this$props$selectedM;

    var _this;

    (0, _classCallCheck2.default)(this, ModeratorTagsComponent);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedModeratorTagNames: (_this$props$selectedM = _this.props.selectedModeratorTags) !== null && _this$props$selectedM !== void 0 ? _this$props$selectedM : [],
      searchText: '',
      moderatorTagsToSelectAfterSearch: _this.props.moderatorTags
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onModeratorTagSelectionChanged", function (newModeratorTagText) {
      if (_this.state.selectedModeratorTagNames.includes(newModeratorTagText)) {
        // If the tag is already selected, remove it
        _this.onModeratorTagRemove(newModeratorTagText);

        return;
      } // If the tag is not selected, add it


      _this.onModeratorTagAdd(newModeratorTagText);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onModeratorTagAdd", function (newModeratorTagText) {
      var moderatorTagsSet = new Set(_this.state.selectedModeratorTagNames);
      moderatorTagsSet.add(newModeratorTagText);

      _this.setState({
        selectedModeratorTagNames: Array.from(moderatorTagsSet)
      }, _this.onChangeSend);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeSend", function () {
      var selectedModeratorTagNames = _this.state.selectedModeratorTagNames;

      _this.props.onChangeModeratorTags(selectedModeratorTagNames);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateSearch", function () {
      var searchText = _this.state.searchText;
      var moderatorTags = _this.props.moderatorTags;
      var moderatorTagsToSelectAfterSearch = moderatorTags.filter(function (moderatorTag) {
        return moderatorTag.text.toLowerCase().includes(searchText.toLowerCase());
      });

      _this.setState({
        moderatorTagsToSelectAfterSearch: moderatorTagsToSelectAfterSearch
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeSearch", function (searchText) {
      _this.setState({
        searchText: searchText
      }, _this.updateSearch);
    });
    _this.onModeratorTagAdd = _this.onModeratorTagAdd.bind((0, _assertThisInitialized2.default)(_this));
    _this.onModeratorTagSelectionChanged = _this.onModeratorTagSelectionChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeSend = _this.onChangeSend.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ModeratorTagsComponent, [{
    key: "onModeratorTagRemove",
    value: function onModeratorTagRemove(moderatorTagText) {
      var _this2 = this;

      var moderatorTagsSet = new Set(this.state.selectedModeratorTagNames);
      moderatorTagsSet.delete(moderatorTagText);
      this.setState({
        selectedModeratorTagNames: Array.from(moderatorTagsSet)
      }, function () {
        return _this2.onChangeSend();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          moderatorTagsToSelectAfterSearch = _this$state.moderatorTagsToSelectAfterSearch,
          searchText = _this$state.searchText;
      return (0, _preact.h)("div", {
        className: "moderator_tags_selector_container widget-configurator_dropdown-selector_container"
      }, (0, _preact.h)(_dropdown.default, {
        size: "full-width",
        textButtonStyle: {
          width: '100%'
        },
        isControl: true,
        popupName: "moderator_tags_selection",
        className: "dropdown-selector",
        trigger: (0, _preact.h)("div", {
          className: "dynamic-content-widget_dropdown-selection"
        }, (0, _preact.h)("label", {
          htmlFor: "dynamic-content-widget_dropdown-selection"
        }, "Moderator tags"), (0, _preact.h)(_Button.default, {
          icon: (0, _preact.h)(_ArrowDropdown.default, {
            width: 24,
            height: 24
          }),
          title: "Select moderator tags",
          fullWidth: true,
          size: "medium",
          style: {
            fontWeight: 'normal'
          },
          id: "dynamic-content-widget_dropdown-selection--moderator-tags"
        }))
      }, (0, _preact.h)("div", null, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: "Search",
        value: searchText,
        onSubmit: function onSubmit() {},
        onInput: function onInput(e) {
          return _this3.onChangeSearch(e.target.value);
        },
        onClear: function onClear() {
          return _this3.onChangeSearch('');
        }
      }), (0, _preact.h)(_NestedDropdown.default, {
        labelId: "moderator-tags",
        items: moderatorTagsToSelectAfterSearch.map(function (moderatorTag) {
          return {
            title: moderatorTag.text,
            id: moderatorTag.text,
            children: []
          };
        }),
        selectedItems: this.state.selectedModeratorTagNames,
        onSelectItem: function onSelectItem(moderatorTagText) {
          return _this3.onModeratorTagSelectionChanged(moderatorTagText);
        },
        onMultiSelect: function onMultiSelect(moderatorTagText) {
          return _this3.onModeratorTagAdd(moderatorTagText);
        },
        depth: 1
      })), moderatorTagsToSelectAfterSearch.length === 0 && (0, _preact.h)(_dropdown.DropdownItem, {
        type: "info"
      }, "No moderator tags found for: ".concat(searchText))), this.state.selectedModeratorTagNames.length > 0 && (0, _preact.h)(_listGroup.default, {
        spacing: "4px"
      }, this.state.selectedModeratorTagNames.map(function (moderatorTag) {
        return (0, _preact.h)(_chip.default, {
          key: moderatorTag,
          variant: "squared",
          size: "small",
          endIcon: (0, _preact.h)(_Close.default, {
            width: 14,
            height: 14
          }),
          onClick: function onClick() {
            _this3.onModeratorTagRemove(moderatorTag);
          }
        }, moderatorTag);
      })));
    }
  }]);
  return ModeratorTagsComponent;
}(_preact.Component);

var _default = (0, _ModeratorTags.withModeratorTagsContext)(ModeratorTagsComponent);

exports.default = _default;